import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useBuyToken, useCheckMinMax, useGetBuyVRS, useGetPillPrice, useICOStatus } from './api/api';
import Web3 from 'web3';
import {
    useAccount,

} from "wagmi";
import { contractAddress } from '../../contract/contractAddress';
import usdtAbi from '../../contract/usdtAbi.json';
import { NumericFormat } from "react-number-format";
import pillMlmAbi from '../../contract/pillMlmAbi.json'
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../Loader/buttonLoad';
import { useToast } from '../../hook/usetoast';
import PropTypes from 'prop-types';
import { decrypt } from '../../hook/encrypt';
import { queryClient } from '../../config';
import { useNavigate } from 'react-router-dom';

const BuyTokenModal = ({ modalOpen, modalClose }) => {




    const getVRS = useGetBuyVRS()
    const navigate = useNavigate()
    const CheckMinMax = useCheckMinMax()
    const { data: pillPrice } = useGetPillPrice()



    const { data: ICOStatus } = useICOStatus()

    const { address,connector } = useAccount();
    const toast = useToast()

   
    const [value, setValue] = useState('')
    const [receiveAmount, setReceiveAmount] = useState(0)
    const [usdtBalanceCheck, setUsdtBalanceCheck] = useState()
    const { balance, setBalance, isloadingconnect, setIsloadingconnect, isBuyToken, setIsBuyToken, check } = useModalContext()
    const [errorMessage, setErrorMessage] = useState("");



    const [buttonEnabled, setButtonEnabled] = useState(false);
    const close = async () => {
        modalClose()
        setValue('')
        setReceiveAmount('')
    }
    const closeBtn = <button className="close" onClick={close}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3359 10.5L16.5547 14.7188C16.7891 14.9531 16.7891 15.3828 16.5547 15.6172L15.5781 16.5938C15.3438 16.8281 14.9141 16.8281 14.6797 16.5938L10.5 12.375L6.28125 16.5938C6.04688 16.8281 5.61719 16.8281 5.38281 16.5938L4.40625 15.6172C4.17188 15.3828 4.17188 14.9531 4.40625 14.7188L8.625 10.5L4.40625 6.32031C4.17188 6.08594 4.17188 5.65625 4.40625 5.42188L5.38281 4.44531C5.61719 4.21094 6.04688 4.21094 6.28125 4.44531L10.5 8.66406L14.6797 4.44531C14.9141 4.21094 15.3438 4.21094 15.5781 4.44531L16.5547 5.42188C16.7891 5.65625 16.7891 6.08594 16.5547 6.32031L12.3359 10.5Z" fill="#6E737E" />
        </svg>
    </button>;
    const buyToken = useBuyToken()

    useEffect(() => {
        usdtBalance()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, usdtBalanceCheck, sessionStorage.getItem('user_JWT'), check,modalOpen])

    const usdtBalance = async () => {
        try {
            const provider = await connector?.getProvider?.();
            const web3 = new Web3(provider);

            const usdtContract = new web3.eth.Contract(usdtAbi, contractAddress?.USDT);
            const usdtUserBalance = await usdtContract.methods.balanceOf(address).call();
            const usdtUserBalanceInUnits = web3.utils.fromWei(usdtUserBalance, 'ether');

            setBalance(usdtUserBalanceInUnits)
        } catch (error) {

        }
    }


    const handleValueChange = async (e) => {

        const value = e.target.value;
        setValue(value);

        const isValid = value > 0 && !isNaN(value);
        await usdtBalance()
        if (parseFloat(value) > balance) {
            setErrorMessage("Insufficient USDT balance");
        } else {
            setErrorMessage("");
        }
        const receivePill = pillPrice?.data?.Pillprice * value;

        setReceiveAmount(receivePill);

        setButtonEnabled(isValid);
    };

    const userBuyVRS = async () => {
        setIsloadingconnect(true)

        try {
            const provider = await connector?.getProvider?.();
            if (!provider) {
                toast.error('Web3 provider not found');
                return;
            }
            const web3 = new Web3(provider);
            const buyContract = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);

            const checkRes = await CheckMinMax.mutateAsync({ amount: receiveAmount })

            if (checkRes?.status) {
                const buyTimeStamp = await buyContract.methods.timeStamp().call()

                const vrsData = {
                    user_address: address,
                    amount: value,
                    deadline: buyTimeStamp.toString()
                }




                const res = await getVRS.mutateAsync(vrsData)


                if (res?.status) {
                    const usdtContract = new web3.eth.Contract(usdtAbi, contractAddress?.USDT);
                    const usdtAllowance = await usdtContract.methods.allowance(address, contractAddress?.pillMLM).call();

                    const valueInWei = web3.utils.toWei(value, 'ether');
                    if (valueInWei > usdtAllowance) {
                        const usdtApprove = await usdtContract.methods.approve(contractAddress?.pillMLM, valueInWei).send({ from: address });

                        if (usdtApprove?.transactionHash) {
                            userBuyToken(valueInWei, decrypt(res?.gcjgnvjfg), decrypt(res?.dfgdgbmn))
                        }
                        return;
                    } else {
                        userBuyToken(valueInWei, decrypt(res?.gcjgnvjfg), decrypt(res?.dfgdgbmn))
                    }

                } else {
                    setIsloadingconnect(false)
                }
            } else {
                setIsloadingconnect(false)
            }


        } catch (error) {

            setIsloadingconnect(false)
        
            const errorMessage = error?.reason || error?.message || "Transaction rejected";
            toast.error(`Transaction Failed: ${errorMessage}`);
        }
    }
    const userBuyToken = async (valueInWei, deadline, signature) => {

        setIsloadingconnect(true)
        const provider = await connector?.getProvider?.();

        if (!provider) {
            toast.error('Web3 provider not found');
            return;
        }
        try {
            setIsloadingconnect(true)
            const web3 = new Web3(provider);
            const buyContract = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);

            const buyGas = await buyContract.methods.buy(0, valueInWei, deadline, signature).estimateGas({ from: address })

            const buyTx = await buyContract.methods.buy(0, valueInWei, deadline, signature).send({ from: address, gas: buyGas })
            if (buyTx?.transactionHash) {
                const userBuyData = {
                    amount: receiveAmount,  //Receive Pill Amount
                    currUsdtValue: pillPrice?.data?.Pillprice, // Current pill price
                    usdtAmount: value, //Usdt Amount
                    transactionId: buyTx?.transactionHash
                }
                const res = await buyToken.mutateAsync(userBuyData)
                if (res?.status) {
                    setUsdtBalanceCheck(res)
                    modalClose()
                    setValue('')
                    queryClient.refetchQueries('stake-balance')
                    queryClient.refetchQueries('stake-history')
                    setIsBuyToken(!isBuyToken)
                    setReceiveAmount('')
                    navigate('/staking-wallet')
                }
            }

        } catch (error) {

            setIsloadingconnect(false)
        
            const errorMessage = error?.reason || error?.message || "Transaction rejected";
            toast.error(`Transaction Failed: ${errorMessage}`);
        } finally {
            setIsloadingconnect(false)

        }

    }

    return (
        <>
            {isloadingconnect && <Loader />}

            <Modal isOpen={modalOpen} centered="true" className="mymodal" backdropClassName="modalbackbg">
                <ModalHeader close={closeBtn}>Buy Token</ModalHeader>
                <ModalBody>
                    <>
                        <div className='form-group formInputs'>
                            <label htmlFor='amount'>Amount</label>
                            <div className='input-group'>
                                <NumericFormat
                                    value={value}
                                    className="form-control"
                                    placeholder="0.00"
                                    allowNegative={false}
                                    onChange={handleValueChange}
                                    disabled={!ICOStatus?.data?.icoStatus}

                                />
                                <div className='input-group-append'>
                                    <div className="input-group-text border-left rounded-0 text-white" style={{ 'borderColor': 'rgba(255,255,255,0.1) !important' }}>
                                        USDT
                                    </div>
                                </div>

                            </div>
                        </div>
                        {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
                        <div className='fs-14 fw-400 mb-3'>Balance <span className="text-primary">{balance} USDT</span></div>
                        <div className="row justify-content-center">
                            <div className="col-sm-8">
                                <div className='darkborderBx'>
                                    <div className='d-flex justify-content-between'>
                                        <span>Received Amount</span>
                                        <span>{receiveAmount ? parseFloat(receiveAmount).toFixed(5) : 0} TPL</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between mt-2'>
                            <label htmlFor="min">Min TPL : {pillPrice?.data?.minBuy} </label>
                            <div>
                                <label htmlFor="max">Max TPL : {pillPrice?.data?.maxBuy} </label>

                            </div>
                        </div>
                        {ICOStatus?.data?.icoStatus ?
                            <div className='text-center'>
                                <div className='mt-4 mb-3'>
                                    <button to={'/'} className='btn btn-primary fs-18 fw-600 px-4 px-lg-5' onClick={userBuyVRS} disabled={!buttonEnabled || errorMessage === 'Insufficient USDT balance'}                                >Submit</button>
                                    <div className="text-white-60 fs-14 fw-400 def-mt-10">Amount Add to stake wallet</div>

                                </div>
                            </div> :
                            <div className='text-center'>
                                <div className='mt-4 mb-3'>
                                    <div className="text-danger fs-14 fw-400 def-mt-10">ICO not available at this moment.</div>
                                </div>
                            </div>
                        }

                    </>
                </ModalBody>
            </Modal>
        </>
    )
}
BuyTokenModal.propTypes = {
    modalOpen: PropTypes.any.isRequired,
    modalClose: PropTypes.any.isRequired,
};
export default BuyTokenModal;